export const isNullOrUndefined = (value: unknown): value is null | undefined => value === null || value === undefined;

export const isNotNullOrUndefined = <T>(value: T | undefined | null): value is T => !isNullOrUndefined(value);

export function assertNotNullOrUndefined<T>(
  value: T | undefined | null,
  message = 'Expected value to not be null or undefined',
): asserts value is T {
  if (isNullOrUndefined(value)) {
    throw new Error(message);
  }
}

export const assertGetNotNullOrUndefined = <T>(value: T | null | undefined, message?: string): T => {
  assertNotNullOrUndefined(value, message);
  return value;
};

// eslint-disable-next-line @typescript-eslint/no-empty-function
export const NOOP = () => {};

export const isStringNotBlank = (value?: string | undefined | null): value is string =>
  isNotNullOrUndefined(value) && value.trim().length > 0;
